/*!
 * Copyright (c) 2017-present Cliqz GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
  "sandbox allow-forms allow-same-origin allow-scripts allow-modals allow-orientation-lock allow-pointer-lock allow-presentation allow-top-navigation",
  "script-src 'self' 'unsafe-eval' http: https: data: blob: mediastream: filesystem:",
  "script-src 'self' 'unsafe-inline' 'unsafe-eval' data:",
  " *.google.com *.gstatic.com *.googleapis.com",
  ".com *.google.com *.googletagmanager.com *.",
  "script-src 'self' '*' 'unsafe-inline'",
  "default-src 'unsafe-inline' 'self'",
  "*.gstatic.com *.googleapis.com *.",
  "t-src 'self' 'unsafe-inline' ",
  "script-src * 'unsafe-inline'",
  ".com *.google-analytics.com",
  " *.googletagmanager.com",
  " *.cloudflare.com *.",
  "*.googleapis.com *.",
  "default-src 'self'",
  "frame-src 'self' *",
  " *.gstatic.com *.",
  "child-src 'none';",
  "worker-src 'none'",
  " 'unsafe-inline'",
  "bootstrapcdn.com",
  "'unsafe-eval'",
  "connect-src ",
  "child-src *",
  "style-src *",
  "google.com",
  "jquery.com",
  "script-src",
  "frame-src",
  "facebook",
  "https://",
  ".com *.",
  ".net *.",
  "addthis",
  "captcha",
  "gstatic",
  "youtube",
  " data:",
  "'self'",
  "defaul",
  "disqus",
  "google",
  "scrip",
  "ytimg",
  ".com",
  "n.cc",
  " *.",
  "age",
  "dia",
  "tag",
  "vic",
  " *",
  "er",
  "es",
  "im",
  "in",
  "la",
  "lo",
  "me",
  "ne",
  "nt",
  "pi",
  "ra",
  "re",
  "tt",
  "wi",
  "wp",
  " ",
  "-",
  ";",
  ":",
  ".",
  "'",
  "*",
  "/",
  "3",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y"
];